import { render, staticRenderFns } from "./krasPlan.vue?vue&type=template&id=515512a7"
import script from "./krasPlan.vue?vue&type=script&lang=js"
export * from "./krasPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515512a7')) {
      api.createRecord('515512a7', component.options)
    } else {
      api.reload('515512a7', component.options)
    }
    module.hot.accept("./krasPlan.vue?vue&type=template&id=515512a7", function () {
      api.rerender('515512a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/plan/krasPlan.vue"
export default component.exports